import { useCallback, useEffect, useRef, useState } from "react";
import { fetchApi } from "../../helper/api";
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import { Bar, Line } from "react-chartjs-2";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { lightGreen, blue, purple } from "@mui/material/colors";
import { VerticalLinearBar } from "./VerticalLinearBar";
import { useParams } from "react-router-dom";
import { param } from "jquery";
import { red } from "material-ui-colors";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);
const ChartMusi = (props) => {
  const [dataChart, setDataChart] = useState(null);
  const [dataReady, setDataReady] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const params = useParams();

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getdata();
    }
    return () => (isMounted = false);
  }, []);

  useEffect(() => {
    if (dataChart) {
      getdataValue();
      setIsLoading(false);
    }
  }, [dataChart]);

  const getdata = async () => {
    const req = await fetchApi(`api/Data/last/${props.sensor}`, "GET", true);
    const res = await req.json();
    const status = req.status;
    if (status === 200 && res.data) {
      setDataChart(res.data);
      setIsLoading(false);
    } else {
      alert(res.message);
    }
  };
  const groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    // console.log("MAP", map);
    return map;
  };

  const getValue = () => {
    let dataPush = [];
    // console.log("PROPS", props.sensor.includes("strtr"));
    // console.log("DATA", dataChart);

    // if (props.sensor.includes("strtr")) {
    // const { dataStrain } = dataChart;
    // dataStrain.map((e, n) => {
    // Object.entries(e).map((d, i) => {
    //       if (d[0] !== "datetime") {
    //         dataPush.push({
    //           type: d[0],
    //           value: d[1] <= 0 ? d[1] * -1 : d[1],
    //         });
    //       }
    //     });
    //   });
    // } else {
    dataChart.map((e, n) => {
      Object.entries(e).map((d, i) => {
        if (d[0] !== "datetime") {
          dataPush.push({
            type: d[0],
            // value: d[1],
            value: d[1] <= 0 ? d[1] * -1 : d[1],
          });
        }
      });
    });
    // }
    const grouped = groupBy(dataPush, (pet) => pet.type);
    return grouped;
  };
  const getdataValue = () => {
    const source = getValue();
    const options = (key) => {
      const roundDown = (number, decimals) => {
        decimals = decimals || 0;
        return (
          Math.floor(number * Math.pow(10, decimals)) / Math.pow(10, decimals)
        );
      };

      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
            fixed: true,
            display: false,
          },
          hover: {
            mode: "nearest",
            intersect: true,
          },
          tooltip: {
            callbacks: {
              title: (p) => {
                return `${p[0].label}`;
              },
              label: (p) => {
                console.log("label:", p);
                const sensor = params.id;
                const label = p.dataset.label.toLowerCase();
                let value = p.raw;
                let unit;
                let valueData = value;
                if (sensor.includes("em")) {
                  if (label === "pressure") {
                    unit = "MPa";
                  } else if (label === "force") {
                    unit = "kN";
                  } else {
                    valueData = (value / 4200) * 100;
                    unit = "%";
                  }
                } else if (sensor.includes("str")) {
                  if (label === "micro_strain") {
                    unit = "µ strain";
                  } else if (label === "mpa") {
                    unit = "MPa";
                  }
                } else if (sensor.includes("acc")) {
                  unit = "G";
                } else if (sensor.includes("dsp")) {
                  unit = "mm";
                } else if (sensor.includes("dmm")) {
                  unit = "mm";
                } else if (sensor.includes("atrh")) {
                  if (label === "temperature") {
                    unit = "°C";
                  } else if (label === "humidity") {
                    unit = "%";
                  }
                } else if (sensor.includes("tilt")) {
                  unit = "°";
                }

                return `${label}: ${Number(valueData).toFixed(2)} ${unit}`;
              },
            },
            mode: "index",
            intersect: true,
          },
          title: {
            display: false,
            text: "",
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true, // SET SCROOL ZOOM TO TRUE
              },
              mode: "x",
              speed: 10,
            },
            pan: {
              enabled: true,
              mode: "x",
              speed: 10,
            },
          },
        },
        elements: {
          point: {
            radius: 3,
            hoverRadius: 4,
            hitRadius: 0,
          },
          line: {
            tension: 0.5,
          },
        },
        scales: params.id.includes("em")
          ? {
              x: {
                stacked: true,
              },
              y: {
                stacked: true,
                beginAtZero: true,
                min: 0,
                max: null,
                ticks: {
                  display: true,
                  stepSize: 420,
                },
                grid: {
                  drawTicks: false,
                },
              },
            }
          : {
              y: {
                beginAtZero: false,
                min:
                  Math.min(
                    ...source.get(key).map((data) => {
                      return data.value;
                    })
                  ) -
                    Math.min(
                      ...source.get(key).map((data) => {
                        return data.value;
                      })
                    ) *
                      0.1 <=
                  0
                    ? 0
                    : roundDown(
                        Math.min(
                          ...source.get(key).map((data) => {
                            return data.value;
                          })
                        ) -
                          Math.min(
                            ...source.get(key).map((data) => {
                              return data.value;
                            })
                          ) *
                            0.1,
                        -1
                      ),
                max: Math.floor(
                  Math.max(
                    ...source.get(key).map((data) => {
                      return data.value;
                    })
                  ) +
                    Math.max(
                      ...source.get(key).map((data) => {
                        return data.value;
                      })
                    ) *
                      0.1
                ),
                ticks: {
                  display: true,
                  stepSize:
                    Math.floor(
                      Math.max(
                        ...source.get(key).map((data) => {
                          return data.value;
                        })
                      )
                    ) / 10,
                },
                grid: {
                  drawTicks: false,
                },
              },
            },
      };
    };
    const labels = getlabel();
    let dataPush = [];
    let no = 0;
    const translateTitle = (text) => {
      let title;
      let tempTitle = "";
      if (text.includes("_")) {
        title = text.split("_");
        title.map((eachText) => {
          tempTitle =
            tempTitle +
            eachText.toString()[0].toUpperCase() +
            eachText.substring(1).toLowerCase() +
            " ";
        });
      } else {
        title = text.split(" ");
        if (title.length <= 1) {
          title.map((eachText) => {
            tempTitle =
              tempTitle +
              eachText.toString()[0].toUpperCase() +
              eachText.substring(1).toLowerCase();
          });
        } else {
          title.map((eachText) => {
            tempTitle =
              tempTitle +
              eachText.toString()[0].toUpperCase() +
              eachText.substring(1).toLowerCase() +
              " ";
          });
        }
      }
      title = tempTitle;
      return title;
    };

    for (let [key, value] of source) {
      no++;
      dataPush.push({
        options: options(key),
        titleLegend: translateTitle(key),
        data: {
          // fill: true,
          labels: labels,
          datasets: params.id.includes("em")
            ? [
                {
                  label: key,
                  data: source.get(key).map((e) => {
                    return e.value;
                  }),
                  ...getColor(no),
                },
                {
                  label: `Remain ${key}`,
                  data: source.get(key).map((e) => {
                    // return 4200 - e.value;
                    return 4200 - e.value;
                  }),
                  backgroundColor: "rgb(185, 189, 185)",
                  borderColor: "rgb(205, 209, 206)",
                },
              ]
            : [
                {
                  label: key,
                  data: source.get(key).map((e) => {
                    return e.value;
                  }),
                  ...getColor(no),
                },
              ],
        },
      });
    }
    // console.log("dataPush", dataPush);
    setDataReady(dataPush);
  };

  useEffect(() => {
    if (dataReady && dataChart) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [dataReady, dataChart]);

  const getColor = (no) => {
    switch (no) {
      case 1:
        return {
          backgroundColor: "rgb(245, 108, 108)",
          borderColor: "rgb(250, 5, 5)",
        };
      case 2:
        return {
          backgroundColor: blue["700"],
          borderColor: blue["700"],
        };
      case 3:
        return {
          backgroundColor: purple["600"],
          borderColor: purple["600"],
        };

      default:
        break;
    }
  };
  const getlabel = () => {
    var label = [];
    // if (props.sensor.includes("strtr")) {
    // const { dataStrain } = dataChart;
    // dataStrain.map((e, i) => {
    // label.push(e.datetime);
    // });
    // } else {
    dataChart.map((e, i) => {
      label.push(e.datetime);
    });
    // }
    return label;
  };

  const handlerRefresh = () => {
    // console.log(props.sensor);
    setIsLoading(true);
    setDataReady();
    setDataChart();
    getdata();
  };

  // console.log("dataReady", dataReady);

  const Content = () => {
    return (
      <>
        <div
          style={{ display: "flex", justifyContent: "right", width: "100%" }}
        >
          <Button
            onClick={() => handlerRefresh()}
            disabled={isLoading}
            variant="outlined"
            startIcon={!isLoading && <i className="las la-redo-alt"></i>}
          >
            {isLoading ? (
              <CircularProgress disableShrink aria-disabled="true" size={20} />
            ) : (
              "Refresh"
            )}
          </Button>
        </div>
        {dataReady?.map((e, i) => {
          return (
            <React.Fragment key={i}>
              <span
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  fontWeight: "400",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                {e.titleLegend}
              </span>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  gap: "10px",
                }}
              >
                {/* <div
                  style={{
                    // flex: "1",
                    alignSelf: "flex-start",
                    height: "75%",
                    minWidth: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // border: "1px solid green",
                    gap: "10px",
                  }}
                >
                  {params.id.includes("em") ? (
                    <VerticalLinearBar
                      data={e.data.datasets[0].data[0]}
                      title="kN"
                      unit="%"
                      sensor={e.titleLegend}
                    />
                  ) : params.id.includes("strtr") ? (
                    <>
                      <VerticalLinearBar
                        sensor="temperature"
                        title="Temp"
                        unit="°C"
                        data={
                          dataChart.dataTemp[
                            parseInt(
                              params.id.substring(params.id.length - 2)
                            ) - 1
                          ]
                            ? dataChart.dataTemp[
                                parseInt(
                                  params.id.substring(params.id.length - 2)
                                ) - 1
                              ]
                            : { value: { temperature: 0 } }
                        }
                      />
                      <VerticalLinearBar
                        sensor="humidity"
                        title="Humidity"
                        unit="%"
                        data={
                          dataChart.dataTemp[
                            parseInt(
                              params.id.substring(params.id.length - 2)
                            ) - 1
                          ]
                            ? dataChart.dataTemp[
                                parseInt(
                                  params.id.substring(params.id.length - 2)
                                ) - 1
                              ]
                            : { value: { humidity: 0 } }
                        }
                      />
                    </>
                  ) : null}
                </div> */}
                <div
                  style={{ flex: "20" }}
                  className="my-4 w-100 overflow-auto"
                  key={i}
                >
                  <div style={{ width: "100%", height: "70vh" }}>
                    {params.id.includes("em") ? (
                      <Bar options={e.options} data={e.data} />
                    ) : (
                      <Line options={e.options} data={e.data} />
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </>
    );
  };

  if (show) {
    return Content();
  } else {
    return (
      <div>
        <h1>Loading...{JSON.stringify(dataReady)}</h1>
      </div>
    );
  }
};

export default ChartMusi;
